import { IconType } from "react-icons";
import { FaRegEye, FaRegPaperPlane, FaRegFlag } from "react-icons/fa";

interface DataType {
    icon: IconType;
    title: {
        ar: string;
        en: string;
    };
    content: {
        ar: string;
        en: string;
    };
}

export const data: DataType[] = [
    {
        icon: FaRegEye,
        title: {
            ar: "رؤيتنا",
            en: "Our Vision",
        },
        content: {
            ar: "أن نكون من الشركات الرائدة في ليبيا في مجال استيراد الفلاتر وقطع غيار الشاحنات والآلات، وأن نُعرف بالجودة والموثوقية وخدمة العملاء المتميزة.",
            en: "To become one of the leading companies in Libya in importing filters and truck spare parts, known for quality, reliability, and excellent customer service.",
        },
    },
    {
        icon: FaRegPaperPlane,
        title: {
            ar: "رسالتنا",
            en: "Our Mission",
        },
        content: {
            ar: "توفير حلول موثوقة وفعّالة لقطاع الشاحنات والمعدات الثقيلة من خلال استيراد منتجات عالية الجودة وبناء علاقات طويلة الأمد مع عملائنا.",
            en: "To provide reliable and effective solutions for the trucking and heavy equipment sector by importing high-quality products and building long-term partnerships.",
        },
    },
    {
        icon: FaRegFlag,
        title: {
            ar: "أهدافنا",
            en: "Our Goals",
        },
        content: {
            ar: "تلبية احتياجات السوق الليبي بمنتجات أصلية وأسعار تنافسية، مع ضمان توفر مستمر وخدمة توريد سريعة ومحترفة.",
            en: "To meet the Libyan market’s needs with original products, competitive prices, continuous availability, and fast professional supply services.",
        },
    },
];
